<script>
  // @ts-check
  import IconScale from "@sourcewhale/shared/svelte-design-system/components/atoms/IconScale.svelte";
  import Bullet from "../components/Bullet.svelte";
  import Bullets from "../components/Bullets.svelte";
  import CTAs from "../components/CTAs.svelte";
  import H1 from "../components/H1.svelte";
  import P from "../components/P.svelte";
  import LicenseChip from "../components/LicenseChip.svelte";
  import Slide from "../components/Slide.svelte";

  import { getIconProps, style } from "../utils";

  const license = "outreach";
  const iconProps = getIconProps(license);
</script>

<Slide>
  <LicenseChip {style} {license} />
  <H1>Your CRM’s missing engagement engine</H1>
  <P>
    Book more meetings, place more candidates and win more business with
    multi-step, multichannel outreach sequences.
  </P>
  <Bullets>
    <Bullet>
      <IconScale class="fa-calendar" {...iconProps} />More meetings, less manual
      work
    </Bullet>
    <Bullet>
      <IconScale class="fa-laptop-mobile" {...iconProps} />Every channel, one
      platform
    </Bullet>
    <Bullet>
      <IconScale class="fa-pen" {...iconProps} />Your messaging, just smarter
    </Bullet>
  </Bullets>
  <CTAs tourLink="https://sourcewhale.navattic.com/tci04cf" />
</Slide>
